import React from 'react';
import { IconWrapper } from 'components/Icon';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const RedMessageBar = ({ message, sx={} }) => {
  return (
    <Stack gap={1} width={1} minHeight={64}
      sx={({ palette }) => ({
        justifyContent: 'flex-start',
        alignItems: 'center',
        bgcolor: "#F28296",
        fontSize: '0.75rem',
        fontWeight: 600,
        cursor: "pointer",
        boxShadow: 25,
        borderRadius: 1,
        borderColor: "#FFF!important",
        flexDirection: "row",
        ...sx,
      })}
    >
      <IconWrapper icon="warning" sx={{height: 24, pl: 2, svg: {stroke: "#B82E46!important", strokeWidth:2}}} />
      <Typography variant="content"
        sx={{
          p: 1,
          fontSize: '0.875rem',
          fontWeight: '500',
          lineHeight: "150%",
        }}
      >
        {message}
      </Typography>
    </Stack>
    // <MuiTextField
    //   name="warning"
    //   required={true}
    //   value={message}
    //   sx={{ mb: 0, ...sx}}
    //   fullWidth
    //   multiline={true}
    //   maxRows={2}
    //   color = "warning"
    //   disabled
    //   slotProps={{
    //     input: {
    //       startAdornment: (
    //         <InputAdornment position="end">
    //           <IconWrapper icon="warning" sx={{height: 24, svg: {stroke: "#B82E46!important", strokeWidth:2}}} />
    //         </InputAdornment>
    //       ),
    //       sx: {
    //         p: 0,
    //         backgroundColor: "#F28296!important",
    //         height:60,
    //         boxShadow:25,
    //         '& .MuiOutlinedInput-notchedOutline': {
    //           borderColor: "#FFF!important",
    //           disabled: true,
    //         },
    //         ...boxSx
    //       },
    //     },
    //     htmlInput: {
    //       sx:{
    //         padding: "0!important",
    //         pl: "12px!important",
    //         fontSize:"0.75rem",
    //         lineHeight: "150%",
    //         fontWeight: 600,
    //       }
    //     },
    //   }}
    // />
  );
};